import { ref, onMounted, onBeforeUnmount, type Ref } from 'vue';

export function useDetectChildClass(containerRef: Ref<HTMLElement | null>, className: string) {
    const hasChildClass = ref(false);
    let observer: MutationObserver | null = null;

    const checkChildClass = () => {
        if (!containerRef.value) {
            hasChildClass.value = false;
            return;
        }
        hasChildClass.value = containerRef.value.querySelector(`.${className}`) !== null;
    };

    onMounted(() => {
        checkChildClass();

        if (containerRef.value) {
            observer = new MutationObserver(() => {
                checkChildClass();
            });

            observer.observe(containerRef.value, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class'],
            });
        }
    });

    onBeforeUnmount(() => {
        if (observer) observer.disconnect();
    });

    return {
        hasChildClass,
    };
}
